import { Controller } from "@hotwired/stimulus"

// Client-side variation selection — fills the personality textarea + intro
// message inputs without a page reload. Preserves whatever the user already
// typed in the name/description fields above.
export default class extends Controller {
  static targets = ["personality", "introInput", "introText", "introBox", "editor"]

  select(event) {
    const { personality, intro } = event.params
    if (this.hasPersonalityTarget) this.personalityTarget.value = personality
    if (this.hasIntroInputTarget) this.introInputTarget.value = intro
    if (this.hasIntroTextTarget) this.introTextTarget.textContent = `"${intro}"`
    if (this.hasIntroBoxTarget) this.introBoxTarget.classList.remove("hidden")
    if (this.hasEditorTarget) this.editorTarget.classList.remove("hidden")

    // Remove the variation cards so the user sees the editor clearly
    const grid = this.element.querySelector(".grid")
    if (grid) grid.remove()
    const pickerHint = this.element.querySelector("p.text-xs.text-fg-muted")
    if (pickerHint && pickerHint.textContent.includes("Pick the variation")) pickerHint.remove()
    const editHint = this.element.querySelector("p.text-\\[10px\\]")
    if (editHint && editHint.textContent.includes("Clicking an option")) editHint.remove()
  }
}
